<ng-container *ngIf="vm.initialized">
	<list-coaching-topics *ngIf="vm.showCoachingTopics && vm.coachingTopics?.length" [coachingTopics]="vm.coachingTopics" [attr.data-search-params]="vm.params"></list-coaching-topics>
	<list-services-instant *ngIf="vm.user?.origin == 'minudoc.ee'"></list-services-instant>
	<section class="c-section c-section--first u-no-pb u-ost-xl@md-and-up" [ngClass]="{'u-osb-xl': vm.user?.origin == 'siffi.com'}" *ngIf="vm.appointments?.length && !vm.showCoachingTopics" panel>
		<div class="c-section__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<h2 class="c-section__title c-section__title--sm">{{ 'Services.Title.Appointment' | translate }} <span class="c-badge c-badge--s1 u-hidden@md-and-up">{{ vm.appointments?.length }}</span></h2>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-hidden@up-to-md u-no-p">
					<a href="{{ vm.avTestUrl }}" class="c-button c-button--s2">{{ 'How_It_Works.Item5-2' | translate }}</a>
				</div>
			</div>
		</div>
		<div class="c-section__content">
			<list-appointments [appointments]="vm.appointments"></list-appointments>
		</div>
	</section>
	<section [hidden]="vm.hideServiceProvidersForCoaching" class="c-section u-no-pb" id="st-services" [ngClass]="{'c-section--first': !vm.appointments?.length}" panel [isOpen]="true">
		<div class="c-section__header">
			<h2 *ngIf="vm.user?.origin == 'minudoc.ee' && !vm.alternativeServicesTitle" class="c-section__title c-section__title--sm c-section__title--offset"><span [innerHtml]="vm.servicesTitle"></span></h2>
			<h2 *ngIf="vm.alternativeServicesTitle && !vm.isInCoachingFlow" style="text-align: center;" class="c-section__title c-section__title--sm">{{ 'Siffi.Services_Title' | translate }}</h2>
			<h2 *ngIf="vm.alternativeServicesTitle && vm.isInCoachingFlow" class="c-section__title c-section__title--sm">{{ 'Siffi.Services_Pick_Doctor' | translate }}</h2>
			<p *ngIf="vm.alternativeServicesTitle && !vm.isInCoachingFlow" style="text-align: center;" class="c-text c-text--wrap u-hidden@up-to-md">{{ 'Siffi.Services_Pick_Doctor' | translate }} <a href="javascript:void(0)" (click)="vm.toggleDrawer($event)">{{ 'How_It_Works.Title' | translate }}</a></p>
		</div>
		<div class="o-grid__cell o-grid__cell--w-fit u-no-p@up-to-md" style="padding-bottom: 15px;" *ngIf="vm.user?.origin == 'siffi.com' && !vm.isInCoachingFlow">
			<div class="o-grid o-grid--column">
				<div *ngIf="vm.user?.origin == 'siffi.com'" class="o-grid__cell--w-100 u-no-p">
					<div class="o-grid o-grid--center-h o-grid--center-v">
						<div class="category-tabs u-no-mb">
							<a id="selectTab{{$index}}" name="selectTab{{$index}}" (click)="vm.handleTabClick($index)" class="category-tabs__link category-tabs__link--sm"
							   [ngClass]="{'category-tabs__link--active': vm.selectedTab === $index}" *ngFor="let tab of vm.tabs ; let $index=index">
								{{ tab.label }}
							</a>
						</div>
					</div>
				</div>
				<div class="o-grid__cell--w-100 u-no-p">
					<div class="c-card u-ost-xl@md-and-up">
						<div class="c-content u-no-p@up-to-md">
							<form class="c-form">
								<div class="o-grid o-grid--wrap">
									<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell@md-and-up" [ngClass]="{'o-grid__cell--w-16@md-and-up': vm.selectedTab === 2, 'o-grid__cell--w-25@md-and-up': vm.selectedTab === 0 || vm.selectedTab === 1 || vm.selectedTab === 3}">
										<div class="o-grid o-grid--fit">
											<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v o-grid__cell--slim c-header__cell u-hidden@md-and-up">
												<button type="button" class="c-button c-button--icon c-button--tp" (click)="vm.isFilterOpen=!vm.isFilterOpen">
													<i class="o-icon o-icon--filter c-text c-text--main u-no-mr" aria-hidden="true"></i>
													<span class="c-badge c-badge--xs c-badge--s1" style="position:absolute;margin-top:-7px;margin-left:12px" *ngIf="vm.search.category || vm.search.lang"></span>
													<span class="u-sr-only">{{ vm.isFilterOpen ? ('Services.Filter.Close' | translate) : ('Services.Filter.Open' | translate) }}</span>
												</button>
											</div>
											<div class="o-grid__cell c-header__cell u-no-p">
												<div class="c-form__group c-form__group--icon u-no-m">
													<label for="term" class="c-form__label u-sr-only">{{ 'Services.Other.Search_Placeholder' | translate }}</label>
													<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
													<input type="text" id="term" name="term" class="c-form__input c-form__input--no-border c-header__input" placeholder="{{ 'Services.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.search.term" (ngModelChange)="onSearchChange($event)">
												</div>
											</div>
										</div>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__filter" [ngClass]="{'c-header__filter--open': vm.isFilterOpen, 'o-grid__cell--w-fill@md-and-up': vm.selectedTab === 2, 'o-grid__cell--w-75@md-and-up': vm.selectedTab === 0 || vm.selectedTab === 1 || vm.selectedTab === 3}">
										<div class="o-grid o-grid--fit o-grid--wrap@up-to-md">
											<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell" [ngClass]="{'o-grid__cell--w-20@md-and-up': vm.selectedTab === 2, 'o-grid__cell--w-25@md-and-up': vm.selectedTab !== 2}">
												<div class="c-form__group u-no-m">
													<label for="lang" class="c-form__label u-sr-only">{{ 'Services.Filter.Languages' | translate }}</label>
													<mat-select [(value)]="vm.search.lang" (closed)="vm.triggerSearch()" class="mat-select" id="lang" placeholder="{{ 'Services.Filter.Languages' | translate }}" multiple data-md-container-class="mat-select-menu2">
														<mat-option *ngFor="let lang of vm.searchLanguages" [value]="lang">{{ ('Services.Language.' + lang) | translate }}</mat-option>
														<mat-select-trigger>{{ vm.getLanguagesText() }}</mat-select-trigger>
													</mat-select>
												</div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell u-hidden@up-to-md" [ngClass]="{'o-grid__cell--w-20@md-and-up': vm.selectedTab === 2, 'o-grid__cell--w-25@md-and-up': vm.selectedTab !== 2}">
												<div class="c-form__group u-no-m">
													<label for="typeOfAppointment" class="c-form__label u-sr-only">{{ 'Subscription.Label.All_Sessions' | translate }}</label>
													<mat-select [(value)]="vm.search.typeOfAppointment" (closed)="vm.triggerSearch()" class="mat-select" id="typeOfAppointment" placeholder="{{ 'Subscription.Label.All_Sessions' | translate }}" data-md-container-class="mat-select-menu2">
														<mat-option [value]="null">
															{{ 'Subscription.Label.All_Sessions' | translate }}
														</mat-option>
														<mat-option *ngFor="let type of vm.typeOfAppointments" [value]="type">
															{{ ('Subscription.Label.' + type) | translate }}
														</mat-option>
													</mat-select>
												</div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell" [ngClass]="{'o-grid__cell--w-20@md-and-up': vm.selectedTab === 2, 'o-grid__cell--w-25@md-and-up': vm.selectedTab !== 2}">
												<div class="c-form__group u-no-m">
													<label for="condition" class="c-form__label u-sr-only">{{ 'Services.Filter.Condition' | translate }}</label>
													<mat-select #conditionSelect="matSelect" [(value)]="vm.search.conditions" [panelWidth]="vm.conditionPanelWidth" (closed)="vm.triggerSearch()" class="mat-select" id="condition" placeholder="{{ 'Services.Filter.Condition' | translate }}" multiple data-md-container-class="mat-select-menu2">
														<mat-option *ngFor="let tag of vm.availableTags" [value]="tag.tag.name">{{ tag.translation }}</mat-option>
														<mat-select-trigger>{{ vm.getConditionsText() }}</mat-select-trigger>
													</mat-select>
												</div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell@md-and-up" *ngIf="vm.selectedTab === 2" [ngClass]="{'o-grid__cell--w-20@md-and-up': vm.selectedTab === 2}">
												<div class="c-form__group u-no-m">
													<label for="therapies" class="c-form__label u-sr-only">{{ 'Services.Filter.Therapies' | translate }}</label>
													<mat-select #therapySelect="matSelect" [(value)]="vm.search.therapies" [panelWidth]="vm.therapyPanelWidth" (closed)="vm.triggerSearch()" class="mat-select" id="therapies" placeholder="{{ 'Services.Filter.Therapies' | translate }}" multiple data-md-container-class="mat-select-menu2">
														<mat-option *ngFor="let therapy of vm.availableTherapies" [value]="therapy.therapy.name">{{ therapy.translation }}</mat-option>
														<mat-select-trigger>{{ vm.getTherapiesText() }}</mat-select-trigger>
													</mat-select>
												</div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 u-no-p" [ngClass]="{'o-grid__cell--w-20@md-and-up': vm.selectedTab === 2, 'o-grid__cell--w-25@md-and-up': vm.selectedTab !== 2, 'u-hidden@up-to-md': vm.selectedTab === 2}">
												<div class="o-grid__cell u-no-p">
													<div class="c-form__group u-no-m">
														<label for="location" class="c-form__label u-sr-only">{{ 'Services.Other.Search_By_Location_Placeholder' | translate }}</label>
														<input type="text" id="location" name="location" class="c-form__input c-form__input--no-border c-header__input" placeholder="{{ 'Services.Other.Search_By_Location_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.search.location" (ngModelChange)="onSearchChange($event)">
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 u-hidden@md-and-up u-no-p c-header__filter" *ngIf="vm.selectedTab === 2" [ngClass]="{'c-header__filter--open': vm.isFilterOpen}" style="border-top: 2px solid #d1d1d1">
										<div class="o-grid o-grid--fit">
											<div class="o-grid__cell o-grid__cell--w-100@up-to-md u-hidden@md-and-up c-header__cell u-no-p">
												<div class="c-form__group c-form__group--icon u-no-m">
													<label for="location" class="c-form__label u-sr-only">{{ 'Services.Other.Search_By_Location_Placeholder' | translate }}</label>
													<i class="o-icon o-icon--home c-form__icon" aria-hidden="true"></i>
													<input type="text" id="locationForMobile" name="locationForMobile" class="c-form__input c-form__input--no-border c-header__input" placeholder="{{ 'Services.Other.Search_By_Location_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.search.location" (ngModelChange)="onSearchChange($event)">
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="c-section__content" id="serviceProviderListContainer" style="overflow:visible">
			<list-services [searchParams]="vm.params"></list-services>
		</div>
	</section>
	<section style="margin-bottom:50px;" class="c-section" panel *ngIf="vm.user?.origin == 'minudoc.ee' && !vm.showCoachingTopics">
		<div class="c-section__header">
			<h2 class="c-section__title c-section__title--sm c-section__title--offset">{{ 'Symptoms.Title' | translate }}</h2>
		</div>
		<div class="c-section__content">
			<div class="o-grid">
				<div class="o-grid__cell c-cell">
					<card-symptoms></card-symptoms>
				</div>
			</div>
		</div>
	</section>
	<div class="o-grid u-ost-xxl u-osb-xxl" *ngIf="vm.user?.origin == 'siffi.com'">
		<div class="o-grid__cell">
			<!-- TODO self help section -->
		</div>
	</div>
</ng-container>
